import { IconProps } from "../../utils/global-types/global-types";

const LogsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    className={className ? className : "w-5 h-5"}
    {...rest}
    fill="none"
    viewBox="0 0 18 18"
  >
    <g clipPath="url(#clip0_9957_116828)">
      <path
        fill="currentColor"
        d="M15.873 5.833h-3.707V2.127zm-4.207 1a.504.504 0 0 1-.5-.5v-4.5H6.333c-1.013 0-1.833.82-1.833 1.834V5.92a5.9 5.9 0 0 1 2.166-.42 5.835 5.835 0 0 1 5.834 5.833 5.83 5.83 0 0 1-2.574 4.834h4.407c1.013 0 1.833-.82 1.833-1.834v-7.5zm-.166 4.5a4.837 4.837 0 0 1-4.834 4.834 4.837 4.837 0 0 1-4.833-4.834A4.837 4.837 0 0 1 6.666 6.5a4.837 4.837 0 0 1 4.834 4.833M8.44 12.4l-1.274-1.273V9.333c0-.273-.226-.5-.5-.5-.273 0-.5.227-.5.5v2a.5.5 0 0 0 .147.354l1.42 1.42c.1.1.227.146.353.146a.5.5 0 0 0 .354-.146.503.503 0 0 0 0-.707"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_9957_116828">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default LogsIcon;
